import {
  Add as AddIcon,
  Phone as PhoneIcon,
  WifiCalling3 as WifiCallingIcon,
  Wifi as WifiIcon,
} from "@mui/icons-material";
import {
  AppBar,
  Box,
  Container,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { allColors } from "../../constants";
import Footer from "../footer";
import { icons, images } from "./../../assets/index";

function Header({ children }) {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar
        component="nav"
        sx={{
          background: "#fff",
          boxShadow: "0px 0px 8px 0px #0000001F",
          borderBottom: `1px solid ${allColors.brightGray}`,
          height: "112px",
        }}
        position="absolute"
      >
        <Container sx={{ maxWidth: "1400px !important" }}>
          <Box
            sx={{
              display: "flex",
              flex: 1,
              justifyContent: "flex-end",
              pt: "10px",
              gap: { xs: 2.5 },
            }}
          >
            <HashLink
              smooth
              to="/#about"
              style={{ color: allColors.jetBlack, textDecoration: "none" }}
            >
              <Typography
                sx={{
                  color: allColors.jetBlack,
                  fontSize: { xs: "12px", sm: "14px" },
                  fontFamily: "Raleway",
                }}
              >
                About
              </Typography>
            </HashLink>
            <HashLink
              smooth
              to="/#contact-us"
              style={{ color: allColors.jetBlack, textDecoration: "none" }}
            >
              <Typography
                sx={{
                  color: allColors.jetBlack,
                  fontSize: { xs: "12px", sm: "14px" },
                  fontFamily: "Raleway",
                }}
              >
                Contact
              </Typography>
            </HashLink>
          </Box>
          <Toolbar
            sx={{
              paddingLeft: "0px !important",
              paddingRight: "0px !important",
              alignItems: "flex-end",
              marginBottom: "20px",
            }}
          >
            <Box
              sx={{
                width: { xs: "41%", sm: "14%" },
                display: { xs: "flex" },
              }}
            >
              <img
                src={images.webLogoImg}
                style={{
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                  objectFit: "contain",
                }}
                onClick={() => navigate("/")}
              />
            </Box>

            <Box
              sx={{
                display: { xs: "flex" },
                flex: 1,
                gap: "10px",
                // marginLeft: "20px",
                justifyContent: { xs: "flex-end", lg: "space-between" },
              }}
            >
              <Box
                sx={{
                  display: {
                    xs: "none",
                    md: "flex",
                    flex: 1,
                    justifyContent: "center",
                    marginRight: "60px",
                  },
                }}
              >
                <HashLink
                  smooth
                  to="/#phone-only"
                  style={{
                    textDecorationLine: "none",
                    display: "flex",
                    border: `1px solid ${allColors.blueCrayola}`,
                    borderRadius: "30px",
                    padding: "6px 14px",
                    alignItems: "center",
                    width: "150px",
                    marginLeft: "20px",
                    cursor: "pointer",
                    background:
                      window.location.hash == "#phone-only"
                        ? allColors.blueCrayola
                        : allColors.white,
                  }}
                >
                  <PhoneIcon
                    sx={{
                      color:
                        window.location.hash == "#phone-only"
                          ? allColors.lightBlack
                          : allColors.blueCrayola,
                      fontSize: "20px",
                    }}
                  />
                  <Typography
                    sx={{
                      color: allColors.lightBlack,
                      fontFamily: "Raleway",
                      fontWeight: "500",
                      fontSize: "12px",
                      marginLeft: "20px",
                    }}
                  >
                    Business Phone
                  </Typography>
                </HashLink>
                <HashLink
                  smooth
                  to="/#broadband-only"
                  style={{
                    textDecorationLine: "none",
                    display: "flex",
                    border: `1px solid ${allColors.jasmine}`,
                    borderRadius: "30px",
                    padding: "6px 14px",
                    margin: "0 12px",
                    alignItems: "center",
                    width: "150px",
                    cursor: "pointer",
                    background:
                      window.location.hash == "#broadband-only"
                        ? allColors.jasmine
                        : allColors.white,
                  }}
                >
                  <WifiIcon
                    sx={{
                      color:
                        window.location.hash == "#broadband-only"
                          ? allColors.lightBlack
                          : allColors.jasmine,
                      fontSize: "20px",
                    }}
                  />
                  <Typography
                    sx={{
                      color: allColors.lightBlack,
                      fontSize: "12px",
                      fontFamily: "Raleway",
                      fontWeight: "500",
                      marginLeft: "10px",
                      width: "150px",
                    }}
                  >
                    Business Broadband
                  </Typography>
                </HashLink>
                <HashLink
                  smooth
                  to="/#phone-broadband"
                  style={{
                    textDecorationLine: "none",
                    display: "flex",
                    border: `1px solid ${allColors.jetBlack}`,
                    borderRadius: "30px",
                    padding: "6px 14px",
                    alignItems: "center",
                    background:
                      window.location.hash == "#phone-broadband"
                        ? allColors.jetBlack
                        : allColors.white,
                  }}
                >
                  <WifiCallingIcon
                    sx={{
                      color:
                        window.location.hash == "#phone-broadband"
                          ? allColors.white
                          : allColors.jetBlack,
                      fontSize: "20px",
                    }}
                  />
                  <Typography
                    sx={{
                      color:
                        window.location.hash == "#phone-broadband"
                          ? allColors.white
                          : allColors.jetBlack,
                      fontSize: "12px",
                      fontFamily: "Raleway",
                      fontWeight: "500",
                      margin: "0 10px",
                      // width:"150px"
                    }}
                  >
                    Phone + Broadband
                  </Typography>
                </HashLink>

                <HashLink
                  smooth
                  // to="/#card-payment"
                  to="/card-payment"
                  style={{
                    textDecorationLine: "none",
                    display: "flex",
                    border: `1px solid ${
                      window.location.pathname == "/card-payment"
                        ? "#F29109"
                        : "#F29109"
                    }`,
                    borderRadius: "30px",
                    padding: "6px 14px",
                    alignItems: "center",
                    marginLeft: "20px",
                    background:
                      window.location.pathname == "/card-payment"
                        ? "#F29109 "
                        : allColors.white,
                  }}
                >
                  <img
                    src= { window.location.pathname == "/card-payment" ? icons.blackCardIcon : icons.brownCardIcon }
                    style={{
                      width: "16px",
                      height: "16px",
                    }}
                  />
                  <Typography
                    sx={{
                      color:
                        window.location.pathname == "/card-payment"
                          ? allColors.jetBlack  
                          : allColors.jetBlack,
                      fontSize: "12px",
                      fontFamily: "Raleway",
                      fontWeight: "500",
                      margin: "0 10px",
                      // width:"150px"
                    }}
                  >
                    Card Payments
                  </Typography>
                </HashLink>
                <HashLink
                  smooth
                  // to="/#card-payment"
                  to="/development-services"
                  style={{
                    textDecorationLine: "none",
                    display: "flex",
                    border: `1px solid ${
                      window.location.pathname == "/development-services"
                        ? "#1F4CFE"
                        : "#1F4CFE"
                    }`,
                    borderRadius: "30px",
                    padding: "6px 14px",
                    alignItems: "center",
                    marginLeft: "20px",
                    background:
                      window.location.pathname == "/development-services"
                        ? "#1F4CFE"
                        : allColors.white,
                  }}
                >
                  <img
                    src= { window.location.pathname == "/development-services" ? icons.whiteDevelopmentIcon : icons.blueDevelopmentIcon }
                    style={{
                      width: "16px",
                      height: "16px",
                    }}
                  />
                  <Typography
                    sx={{
                      color:
                        window.location.pathname == "/development-services"
                          ? allColors.white  
                          : allColors.jetBlack,
                      fontSize: "12px",
                      fontFamily: "Raleway",
                      fontWeight: "500",
                      margin: "0 10px",
                      // width:"150px"
                    }}
                  >
                    Development Services
                  </Typography>
                </HashLink>
              </Box>
              <Box sx={{ display: { xs: "flex" } }}>
                <Box
                  sx={{
                    display: "flex",
                    // border: `1px solid ${allColors.blueCrayola}`,
                    borderRadius: "30px",
                    padding: { xs: "6px 7px", sm: "6px 14px" },
                    cursor: "pointer",
                    alignItems: "center",
                  }}
                >
                  <a
                    href="tel:02076299888"
                    style={{ marginLeft: "10px", textDecoration: "none" }}
                  >
                    <PhoneIcon
                      sx={{
                        color:
                          window.location.hash == "#phone-only"
                            ? allColors.lightBlack
                            : allColors.blueCrayola,
                        fontSize: "20px",
                      }}
                    />
                    {/* <Typography
                      sx={{
                        color: allColors.blueCrayola,
                        fontSize: "15px",
                        fontFamily: "Squad-Regular",
                        fontWeight: "700",
                      }}
                    >
                      0845 561 2525
                    </Typography> */}
                  </a>
                </Box>
                <img
                  src={icons.profileCircleIcon}
                  style={{
                    width: "30px",
                    height: "30px",
                    cursor: "pointer",
                    marginLeft: "8px",
                  }}
                  alt="profile-icon"
                />
                {/* <img
                  src={icons.menuCircleIcon}
                  style={{
                    display: isSmallScreen ? "block" : "none",
                    width: "30px",
                    height: "30px",
                    cursor: "pointer",
                    marginLeft: "8px",
                  }}
                  alt="menu-icon"
                  onClick={handleClick}
                /> */}
              </Box>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Box
        sx={{
          display: { xs: "flex", md: "none" },
          alignItems: "flex-start",
          justifyContent: "center",
          position: "absolute",
          top: { xs: "112px", sm: "113px" },
          left: 0,
          right: 0,
          width: "100%",
          zIndex: 1100,
          gap: { xs: "6px", sm: "10px" },
          px: { xs: "10px", sm: "16px" },
          boxSizing: "border-box",
        }}
      >
        <HashLink
          smooth
          to="/#phone-only"
          style={{
            flex: 1,
            maxWidth: "68px",
            background: "#1f75fe",
            borderRadius: "0 0 25px 25px",
            padding: "6px 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 10px rgba(31,117,254,0.25)",
            transition: "transform 0.2s ease",
          }}
        >
          <PhoneIcon sx={{ color: allColors.jetBlack, fontSize: "20px" }} />
        </HashLink>
        <HashLink
          smooth
          to="/#broadband-only"
          style={{
            flex: 1,
            maxWidth: "68px",
            background: "#ffd97c",
            borderRadius: "0 0 25px 25px",
            padding: "6px 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 10px rgba(255,217,124,0.35)",
            transition: "transform 0.2s ease",
          }}
        >
          <WifiIcon sx={{ color: allColors.jetBlack, fontSize: "20px" }} />
        </HashLink>
        <HashLink
          smooth
          to="/#phone-broadband"
          style={{
            flex: 1,
            maxWidth: "78px",
            background: "#F29109",
            borderRadius: "0 0 25px 25px",
            padding: "6px 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 10px rgba(242,145,9,0.3)",
            transition: "transform 0.2s ease",
          }}
        >
          <PhoneIcon
            sx={{
              color: { xs: allColors.jetBlack, sm: allColors.white },
              fontSize: "18px",
            }}
          />
          <AddIcon
            sx={{
              color: { xs: allColors.jetBlack, sm: allColors.white },
              fontSize: "10px",
              margin: "0 4px",
            }}
          />
          <WifiIcon
            sx={{
              color: { xs: allColors.jetBlack, sm: allColors.white },
              fontSize: "18px",
            }}
          />
        </HashLink>
        <HashLink
          smooth
          to="/card-payment"
          style={{
            flex: 1,
            maxWidth: "68px",
            background: "#F29109",
            borderRadius: "0 0 25px 25px",
            padding: "6px 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 10px rgba(242,145,9,0.3)",
            transition: "transform 0.2s ease",
          }}
        >
          <img
            src={window.location.pathname == "/card-payment" ? icons.blackCardIcon : icons.blackCardIcon}
            style={{
              width: "16px",
              height: "16px",
            }}
          />
        </HashLink>
        <HashLink
          smooth
          to="/development-services"
          style={{
            flex: 1,
            maxWidth: "68px",
            background: "#1F4CFE",
            borderRadius: "0 0 25px 25px",
            padding: "6px 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 10px rgba(31,76,254,0.3)",
            transition: "transform 0.2s ease",
          }}
        >
          <img
            // src={window.location.pathname == "/development-services" ? icons.blueDevelopmentIcon : icons.whiteDevelopmentIcon}
            src={icons.whiteDevelopmentIcon}
            style={{
              width: "16px",
              height: "16px",
            }}
          />
        </HashLink>
      </Box>

      <Box
        component="main"
        sx={{
          overflowX: "auto",
          width: "100%",
        }}
      >
        <Toolbar />
        {children}
        <Footer />
      </Box>
    </Box>
  );
}

export default Header;
